import React, { useState } from "react";
import CustomTable from "../components/Table";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const BudgetRevenue = () => {
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState("");

    const data = [
        {
            id: 1,
            name: "Office Supplies",
            category: "Category",
            sub: "14 Jan 2024",
            amount: "250000",
            date: "14 Nov 2024",
        },
    ];

    const filtered = data;
    const columns = [
        { title: "Revenue Name", dataIndex: "name" },
        { title: "Category", dataIndex: "category" },
        { title: "Sub Category", dataIndex: "sub" },
        { title: "Amount", dataIndex: "amount" },
        { title: "Date", dataIndex: "date" },
        {
            title: "Action",
            render: () => (
                <div className="action-icons">
                    <EditOutlined />
                    <DeleteOutlined />
                </div>
            ),
        },
    ];

    return (
        <CustomTable
            title="Budget Revenue"
            columns={columns}
            data={filtered}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onSearch={setSearch}
        />
    );
};

export default BudgetRevenue;